import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect, G } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PercentIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Percent`} {...props}>
    <G
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <Path d="m5 13.5 6-11" />
      <Rect width={3} height={4} x={10} y={9} rx={1.5} />
      <Rect width={3} height={4} x={3} y={3} rx={1.5} />
    </G>
  </Icon>
);
